import React from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './components/App'

export function startReportsApp() {
  const root = createRoot(document.getElementById('reports-app'))
  root.render(<App />)
}
